<template>
    <div class="page">
            <div v-if="!isSuccess" >
                <router-link :to="{ name: 'RegisterClient' }" tag="h1" class="mb-5">Aanmelden als opdrachtgever</router-link>
                <form @submit.prevent="register">
                    <div class="form-group">
                        <label for="Email" hidden>Email:</label>
                        <input 
                        placeholder="Email..." 
                        name="Email" 
                        id="Email" 
                         type="email"
                        :class="['form-control', ($v.registerModel.email.$dirty) ? ($v.registerModel.email.$error) ?'is-invalid' : 'is-valid' : '']"
                        v-model="registerModel.email" 
                        :disabled="isLoading" 
                        @change="$v.registerModel.$touch"
                        >
                    </div>
                    <div class="form-group">
                        <label for="Password" hidden>Wachtwoord:</label>
                        <input 
                        placeholder="Wachtwoord..." 
                        name="Password" 
                        id="Password" 
                        :class="['form-control', ($v.registerModel.password.$dirty) ? ($v.registerModel.password.$error) ?'is-invalid' : 'is-valid' : '']"
                        type="password" 
                        v-model="registerModel.password" 
                        :disabled="isLoading" 
                        @change="$v.registerModel.$touch"
                        >
                    </div>
                    <div class="form-group">
                        <label for="ConfirmPassword" hidden>Bevestig Wachtwoord:</label>
                        <input 
                        placeholder="Bevestig Wachtwoord..." 
                        name="ConfirmPassword" 
                        id="ConfirmPassword" 
                        :class="['form-control', ($v.registerModel.confirmPassword.$dirty) ? ($v.registerModel.confirmPassword.$error) ?'is-invalid' : 'is-valid' : '']"
                        type="password" 
                        v-model="registerModel.confirmPassword" 
                        :disabled="isLoading" 
                        @change="$v.registerModel.$touch"
                        >
                    </div>
                    <div class="form-group text-right">
                        <loader width="3rem" class="mr-3" v-if="isLoading"></loader>
                        <button type="confirm" :class="['btn btn-half btn-lg mb-3', $v.registerModel.$invalid ? 'btn-outline-azure' : 'btn-azure-dark']" :disabled="isLoading || $v.registerModel.$invalid" v-else> 
                            <span>Aanmelden als <br /> opdrachtgever</span>
                            <div class="btn-icon">
                                <span>&rarr;</span>
                            </div>
                        </button>
                    </div>
                    <transition name="slide">
                        <div class="alert alert-warning" role="alert" v-if="(registerModel.password != null && $v.registerModel.password.$invalid) || (registerModel.confirmPassword != null && $v.registerModel.confirmPassword.$invalid)">
                            <ul class="mb-0">
                                <li v-if="registerModel.password != registerModel.confirmPassword && !!registerModel.confirmPassword">Wachtwoorden moeten overeenkomen</li>
                                <li v-if="registerModel.password.length < 6">Wachtwoord moet minimaal 6 karakters zijn</li>
                                <li v-if="!/[^a-zA-Z\d\s:]/.test(registerModel.password)">Wachtwoord moet minimaal 1 speciaal karakter bevatten</li>
                                <li v-if="!/[a-z]/.test(registerModel.password)">Wachtwoord moet minimaal kleine letter bevatten</li>
                                <li v-if="!/[A-Z]/.test(registerModel.password)">Wachtwoord moet minimaal hoofdletter bevatten</li>
                                <li v-if="!/\d/.test(registerModel.password)">Wachtwoord moet minimaal cijfer bevatten</li>
                            </ul>
                        </div>
                    </transition>
                    <div class="alert alert-danger" role="alert" v-if="isError">
                        <strong>Oeps!</strong> 
                        <ul>
                            <li v-for="err in errors" :key="err">{{err}}</li>
                        </ul>
                    </div>
                </form>
            </div>
            <div v-else>
                <h1>Registratie voltooid</h1>
                <div class="alert alert-success" role="alert">
                    <strong>Bedankt!</strong> 
                    <br>
                    <p>
                        U ontvangt een email om uw emailadres te bevestigen. Voor vragen kunt u altijd contact met ons opnemen via <a href="mailto:info@azurity.nl">info@azurity.nl</a>.
                    </p>
                </div>
            </div>
        <transition name="fade" mode="in-out" v-if="isSuccess">
            <div class="bg-azure-light p-5 text-center col-md-12" >
                <h5 class="m-0 p-0">Uw wordt in {{timer}} seconden doorgestuurd naar de <router-link :to="{ name: 'LoginClient'}" tag="a">login pagina</router-link>.</h5>
            </div>
        </transition>
    </div>
</template>

<script>
import Loader from '@/components/Loader';
import { validationMixin } from 'vuelidate';
import { required, minLength, email, sameAs, helpers } from 'vuelidate/lib/validators';

const hasUpper = helpers.regex('hasSpecialCharacter', /[A-Z]/);
const hasLower = helpers.regex('hasLower', /[a-z]/);
const hasNumber = helpers.regex('hasSpecialCharacter', /\d/);
const hasSpecialCharacter = helpers.regex('hasSpecialCharacter', /[^a-zA-Z\d\s:]/);    
export default {
    components: {
        'loader': Loader
    },
    mixins: [validationMixin],
    data() {
        return {
            isLoading: false,
            isSuccess: false,
            isError: false,
            errors: [],
            timer: 10,
            registerModel: {
                email: null,
                password: null,
                confirmPassword: null,
                type: 'client'
            }
        }
    },
    validations: {
        registerModel: {
            email: {
                required,
                email
            },
            password: {
                required,
                hasUpper,
                hasLower,
                hasNumber,
                hasSpecialCharacter,
                minLength: minLength(6),
            },
            confirmPassword: {
                required,
                minLength: minLength(6),
                sameAs: sameAs('password'),
            }
        }
    },
    methods: {
        register() {
            this.$v.registerModel.$touch();
            if(this.$v.registerModel.$invalid)
                return;

            this.isSuccess = false;
            this.isError = false;
            this.errors = [];
            
            if(this.registerModel.password != this.registerModel.confirmPassword && !!this.registerModel.confirmPassword)
            {
                this.errors.push("Wachtwoorden komen niet overeen.");
                this.isError = true;
                return;
            }

            if(this.registerModel.password.length < 6)
            {
                this.errors.push("Wachtwoord moet minimaal 6 tekens zijn.");
                this.isError = true;
            }
            
            if(!/[a-z]/.test(this.registerModel.password))
            {
                this.errors.push('Wachtwoord moet minimaal 1 kleine letter bevatten.');
                this.isError = true;
            }

            if(!/[A-Z]/.test(this.registerModel.password))
            {
                this.errors.push('Wachtwoord moet minimaal 1 hoofdletter letter bevatten.');
                this.isError = true;
            }

            if(!/\d/.test(this.registerModel.password))
            {
                this.errors.push('Wachtwoord moet minimaal 1 cijfer bevatten.');
                this.isError = true;
            }

            if(!/[^a-zA-Z\d\s:]/.test(this.registerModel.password))
            {
                this.errors.push('Wachtwoord moet minimaal 1 speciaal karakter bevatten.');
                this.isError = true;
            }
            
            if(this.isError)
            {
                return;
            }

            if(!this.isError)
            {
                this.isLoading = true;
                this.$http.post('api/Auth/Register?referral=' + this.$route.query.referral, this.registerModel)
                .then(() =>
                {
                    this.$store.dispatch('AUTH_LOGIN', 
                    {
                        userName: this.registerModel.email,
                        password: this.registerModel.password,
                        rememberMe: true,
                        type: 'Client'
                    }).then(() => {
                        if(this.$store.getters.isAuthenticated)
                        {
                            this.$router.push({ name: 'Client' })
                        } else {
                            this.$router.push({ name: 'LoginProfessional'});
                        }
                        this.isLoading = false;
                    }).catch(() => {
                        this.isLoading = false;
                    });
                })
                .catch((err) => {
                    this.errors.push((err.data == null || err.data == '') ? 'Wachtwoord niet correct, probeer nogmaals.' : err.data);
                    this.isError = true;
                    this.isLoading = false;
                });
            }
        }
    }
}
</script>